var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUndrawSavingsReEq4W(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 300,
    height: 300,
    viewBox: "0 0 740.67538 197.17519",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M640.79,303.42a59,59,0,0,1-118,0c0-1.87.08984-3.71.25976-5.53A59,59,0,0,1,640.79,303.42Z",
    transform: "translate(-229.66231 -151.4124)",
    fill: "#e6e6e6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M599.35986,307.34a14.04753,14.04753,0,0,0-5.46972-4.33,53.13872,53.13872,0,0,0-8.22022-2.7V284.25a23.39587,23.39587,0,0,1,11.68994,5.33l3.26026-6.95a21.56068,21.56068,0,0,0-6.36035-3.93,31.25931,31.25931,0,0,0-8.06983-2.07v-8.14h-7.5498v8.22a20.67243,20.67243,0,0,0-8.25,2.77,16.3988,16.3988,0,0,0-5.59034,5.48,13.77113,13.77113,0,0,0-1.98974,7.29,12.46275,12.46275,0,0,0,2.29,7.8,14.51022,14.51022,0,0,0,5.6997,4.52,52.69206,52.69206,0,0,0,8.36036,2.77v15.39A24.98812,24.98812,0,0,1,565.25,317.18l-3.25977,6.96a24.58042,24.58042,0,0,0,7.43995,4.22,34.16142,34.16142,0,0,0,9.21,1.92v8.07h7.5498v-8.22a19.5385,19.5385,0,0,0,11.21-5.14,13.58959,13.58959,0,0,0,4.18018-10.1A12.0549,12.0549,0,0,0,599.35986,307.34Zm-20.1997-8.73a14.49857,14.49857,0,0,1-5.03028-2.7,5.32046,5.32046,0,0,1-1.77978-4.18,6.72557,6.72557,0,0,1,1.81982-4.81,9.20221,9.20221,0,0,1,4.99024-2.59Zm11.25,21.28a8.5575,8.5575,0,0,1-4.74024,2.47V309.12a13.23964,13.23964,0,0,1,4.74024,2.37,4.65775,4.65775,0,0,1,1.62988,3.7A6.8039,6.8039,0,0,1,590.41016,319.89Z",
    transform: "translate(-229.66231 -151.4124)",
    fill: "#009688"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawSavingsReEq4W);
export default __webpack_public_path__ + "static/media/undraw_savings_re_eq4w.50c8229a2794d17d6264f10950b6afe6.svg";
export { ForwardRef as ReactComponent };